import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptHistoricoDispositivos, IRequestGetRptHistoricoDispositivos } from "./services";

const initialState: any = {
  status: "",
  noContent: true
};

export const actionGetRptHistoricosDispositivos: any = createAsyncThunk<any, IRequestGetRptHistoricoDispositivos>(
  "ACTION_GET_RPT_HISTORICOS_DISPOSITIVOS",
  async (data, { getState }: any) => {
    const {
      getLojas: {
        lojaSelected,
        lojaSelectedInfos: { nome },
      },
    } = getState();

    const result = await getRptHistoricoDispositivos({
      ...data,
      idLoja: lojaSelected,
    });

    download(result, { ext: data.reportType, fileName: `relatorio-${nome}` });

    return result;
  }
);

const sliceGetRptHistoricosDispositivos = createSlice({
  name: "GET_RPT_HISTORICO_DISPOSITIVOS",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetRptHistoricosDispositivos.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetRptHistoricosDispositivos.fulfilled]: (state, { payload: { status } }) => {
      state.status = "success";
      state.noContent = status === 204;
    },
    [actionGetRptHistoricosDispositivos.rejected]: (state) => {
      state.status = "failed";
    },
  },
});

export default sliceGetRptHistoricosDispositivos.reducer;
